var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.588,
    height: 12.529
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "Icon - Lock",
    transform: "translate(.26 .26)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.088,
    height: 5.964,
    "data-name": "Rectangle 581",
    rx: 1.125,
    transform: "translate(.49 5.555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.961 5.555V3.063a2.574 2.574 0 015.147 0v2.492",
    "data-name": "Path 4301"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjU4OCIgaGVpZ2h0PSIxMi41MjkiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzRmNTU1OCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZGF0YS1uYW1lPSJJY29uIC0gTG9jayIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjI2IC4yNikiPjxyZWN0IHdpZHRoPSI4LjA4OCIgaGVpZ2h0PSI1Ljk2NCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNTgxIiByeD0iMS4xMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC40OSA1LjU1NSkiLz48cGF0aCBkPSJNMS45NjEgNS41NTVWMy4wNjNhMi41NzQgMi41NzQgMCAwIDEgNS4xNDcgMHYyLjQ5MiIgZGF0YS1uYW1lPSJQYXRoIDQzMDEiLz48L2c+PC9zdmc+";
export { SvgLock as ReactComponent };